import {
    GET_GENERAL_EXAM_BY_CUSTOMER,
    GET_SPECIFIC_GENERAL_EXAM,
    UPDATE_SPECIFIC_GENERAL_EXAM,
    REMOVE_GENERAL_EXAM,
} from '@/redux/actions/types';

/**
 * initial state cho module GeneralExam
 */
const INIT_STATE = {
    generalExamList: [],      // danh sách phiếu khám
    currentGeneralExam: null, // record chi tiết (edit)
    pagination: {
        currentPage: 1,
        total: 0,
        perPage: 50
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        // Lấy danh sách phiếu khám theo customer
        case GET_GENERAL_EXAM_BY_CUSTOMER: {
            return {
                ...state,
                generalExamList: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page || 1),
                    total: parseInt(action.payload.total || 0),
                    perPage: parseInt(action.payload.per_page || 50),
                }
            };
        }

        // Lấy 1 phiếu khám (dùng khi update)
        case GET_SPECIFIC_GENERAL_EXAM: {
            return {
                ...state,
                currentGeneralExam: action.payload
            };
        }


        // Cập nhật 1 phiếu khám
        case UPDATE_SPECIFIC_GENERAL_EXAM: {
            const updatedList = state.generalExamList.map(item =>
                item.id === action.payload.id ? action.payload : item
            );

            return {
                ...state,
                generalExamList: updatedList,
                currentGeneralExam: action.payload
            };
        }

        // Xóa một hoặc nhiều phiếu khám
        case REMOVE_GENERAL_EXAM: {
            const filteredList = state.generalExamList.filter(
                item => !action.payload.includes(item.id)
            );

            return {
                ...state,
                generalExamList: filteredList,
                pagination: {
                    ...state.pagination,
                    total: state.pagination.total - action.payload.length
                }
            };
        }

        default:
            return { ...state };
    }
};
